import type { FaireProductEntity } from "../../entity_types/product";

export const p_7h8xjqxrnt: FaireProductEntity = {
  token: "p_7h8xjqxrnt",
  type: "product",
  name: "Patchwork Flowy Mini Skirt with Pockets",
  brandToken: "b_7rkbvdp47b",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9629f9cfe900a065891bea57402788b1eecca5c7d2bc4b5faa90cad8e4c1f0cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85020f7c8126bed5c10fc67987848f8c86bbd22ca6715a1b70f19d7ebd3fa99a.jpeg",
    "https://cdn.faire.com/fastly/235ce2ee4622f96be28df978c9e64f4ea907eb5212fa7dedbaa0196e831968c6.jpeg",
    "https://cdn.faire.com/fastly/e611592109de565d3e2723a6faceb61fe85743d34a498bfa5df31efa7e9c05bc.jpeg",
    "https://cdn.faire.com/fastly/0d1fe2d9495e2eabd9ca0a6fb89756a255baa637121b792981029ecae0ade831.jpeg",
    "https://cdn.faire.com/fastly/5b69b86632dccd36ba0aa91bba79c5cdc3d1fe10f5cb84bbe67d9fc8a0142816.jpeg",
    "https://cdn.faire.com/fastly/c0bdbdce1e1d8ccae3ebb345874e992144bc555a1401fc6759fcaaf7d88d452e.jpeg",
    "https://cdn.faire.com/fastly/d864bf3257aef25444e30d7b56b08df1288156bea14ea646c1320535acac2a54.jpeg",
    "https://cdn.faire.com/fastly/c78b81fc52ff8ef207d416d02bf4d67b7a5aaf5d52ef107c1ed9f2d046a95b08.jpeg",
    "https://cdn.faire.com/fastly/bf775c4a2cbe887444d059ee2cad742395294501a8893aa8d65b880731ab1e0a.jpeg",
    "https://cdn.faire.com/fastly/19ba62f2694af3b3f063c96c349e9518232a1f3a55c83dea0e9cc705433a9e71.jpeg",
    "https://cdn.faire.com/fastly/b0542bc66f800666ebed3a7d32ef1066a2d7149a13f98cc2294338f979f9af42.jpeg",
    "https://cdn.faire.com/fastly/749215cf55cedd1377513568785f44b174a82a303bfe957fed7184e480dd516e.jpeg",
    "https://cdn.faire.com/fastly/b06fbe80f22c39bfc51b8b9c0fb768ce157372fa05cd6c89093206f9709724b2.jpeg",
  ],
  priceDollars: 30.49,
  description:
    "Handmade patchwork mini skirt in breathable 100% cotton with artisanal block-print panels, scalloped lace hem, and deep pockets. A comfy elastic/drawstring waist creates a size-inclusive fit that flatters many shapes—perfect for festivals, fairycore/cottagecore looks, and everyday boho style. Ethically crafted, lightweight, and easy to style with crop tops, tees, or boots.\n\nHandmade in Nepal\nMaterial: Cotton\nSize: One Size and Plus Size\n**This skirt has a elastic waist with a drawstring to adjust along with two side pockets.\n\nMEASUREMENTS\n\nONE SIZE MEASUREMENT\nLength: Approx. 18 inches\nWaist: Fits up to Approx. 40 inches\n\nPLUS SIZE MEASUREMENTS\nLength: Approx. 18 inches\nWaist: Fits up to Approx. 48 inches\n\n** ETHICALLY SOURCED\n** SLOW FASHION\n** SUSTAINABLE FASHION",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:49.354Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
